import { roleDisplayName } from "./requestTransparency";

export function requisitionCreatorId(row) {
  return row?.createdById || row?.createdBy?.id || row?.request?.createdById || "";
}

export function isOwnRequisition(row, user) {
  const creatorId = requisitionCreatorId(row);
  return Boolean(user?.id && creatorId && String(creatorId) === String(user.id));
}

export function isOpenRequisition(row) {
  const status = row?.status || row?.request?.status;
  return status === "PENDING" || status === "IN_PROGRESS";
}

export function currentRequisitionApproverSlug(row) {
  return row?.nextApprover?.approverRole?.slug || null;
}

export function canActOnRequisition(row, user) {
  if (!isOpenRequisition(row) || isOwnRequisition(row, user)) return false;
  const slug = currentRequisitionApproverSlug(row);
  if (!slug) return false;
  const roles = user?.backendRoles || [];
  if (roles.includes(slug)) return true;
  return slug === "hr" && (roles.includes("hr") || roles.includes("hr_staff"));
}

export function requisitionCreatorName(row) {
  return (
    row?.createdByName ||
    row?.createdBy?.employee?.fullName ||
    row?.request?.createdBy?.employee?.fullName ||
    row?.createdBy?.username ||
    row?.request?.createdBy?.username ||
    "—"
  );
}

export function requisitionStatusLabel(status) {
  if (status === "APPROVED") return "معتمد";
  if (status === "PENDING" || status === "IN_PROGRESS") return "بانتظار الموافقة";
  if (status === "REJECTED") return "مرفوض";
  if (status === "CANCELLED") return "ملغى";
  return status || "—";
}

export function requisitionNextApproverLabel(row) {
  if (!isOpenRequisition(row)) return "—";
  const slug = currentRequisitionApproverSlug(row);
  const role = roleDisplayName(
    slug,
    row?.nextApprover?.approverRole?.name || row?.nextApprover?.roleName,
  );
  const names = (row?.nextApproverPeople || [])
    .map((person) => (typeof person === "string" ? person : person?.name))
    .map((name) => String(name || "").trim())
    .filter(Boolean);
  if (!slug && !names.length) return "—";
  if (names.length === 1) return `${names[0]} — ${role}`;
  if (names.length > 1) return `${names.join("، ")} — ${role}`;
  return role || "—";
}
